export default __webpack_public_path__ + "static/media/0b.ebd4b102.jpg";